// extracted by mini-css-extract-plugin
module.exports = {"section":"e_pW","card":"e_qW"};